/**
 * Fallback imagery when `templateImageUrl` is not set.
 * Harbor / cruise hero (not pool resort) — matches certificate landing design.
 */
export const LANDING_DEFAULT_HERO_IMAGE =
  'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=1920&q=80';

/** Per–product-type thumbnails in showcase / story (hotel & condo keep resort looks). */
export const LANDING_DEFAULT_PRODUCT_IMAGES: Record<string, string> = {
  cruise: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=1200&q=80',
  hotel: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80',
  condo: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1200&q=80',
};
